// Unit of Measure constants shared across the application

export const uomItems = [
    { id: 1, label: '', value: '' },
    { id: 2, label: 'items', value: 'items' },
    { id: 3, label: 'slices', value: 'slices' },
    { id: 4, label: 'buns', value: 'buns' },
    { id: 5, label: 'people', value: 'people' },
    { id: 6, label: 'units', value: 'units' },
    { id: 7, label: 'pairs', value: 'pairs' },
    { id: 8, label: 'boxes', value: 'boxes' },
    { id: 9, label: 'pcs', value: 'pcs' },
    { id: 10, label: 'quarts', value: 'quarts' },
    { id: 11, label: 'gallons', value: 'gallons' },
];

// For components that need simple string array format
export const uomItemsSimple = uomItems.map((item) => item.label || item.value);
